var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 33,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M33.486 24.378c-2.818 3.493-10.658 1.962-17.209-3.257-6.55-5.219-9.79-12.535-6.687-16.14 0 0-2.16 2.6-2.254 2.795-2.817 3.493.23 10.725 6.687 16.14 6.743 5.302 14.39 6.75 17.209 3.256 0 0 2.16-2.599 2.254-2.794Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M31.44 26.762c-2.82 3.497-10.663 1.964-17.218-3.259-6.554-5.223-9.794-12.546-6.69-16.154 0 0 .941-1.007 1.505-1.706-.657.895-1.691 2.098-1.784 2.293-2.82 3.497.23 10.735 6.69 16.154 6.747 5.307 14.399 6.756 17.218 3.26 0 0 1.128-1.399 1.784-2.294-.563.7-1.505 1.706-1.505 1.706Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M16.034 21.113C9.276 15.79 6.222 8.53 9.331 4.91l-.279.589c-2.824 3.506.23 10.767 6.703 16.202 6.472 5.435 14.423 6.776 17.247 3.27l.28-.59c-2.824 3.507-10.682 1.97-17.248-3.27Z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M33.233 24.494c-2.841 3.528-10.646 2.057-17.131-3.125C9.616 16.188 6.453 8.874 9.58 5.231c3.127-3.643 10.647-2.057 17.132 3.124 6.485 5.182 9.648 12.495 6.521 16.139Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M33.242 24.49c-2.843 3.53-10.65 2.058-17.136-3.125C9.619 16.18 6.646 8.948 9.488 5.418c2.843-3.53 10.65-2.058 17.136 3.125 6.487 5.184 9.46 12.418 6.618 15.947Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M33.045 24.403c-2.842 3.53-10.649 2.058-17.135-3.126C9.423 16.093 6.45 8.859 9.293 5.33c2.843-3.53 10.65-2.058 17.136 3.126 6.486 5.184 9.46 12.417 6.616 15.947Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M33.045 24.403c-2.842 3.53-10.458 2.14-17.135-3.126C9.233 16.011 6.45 8.859 9.293 5.33 12.136 1.8 19.752 3.19 26.43 8.456s9.46 12.417 6.616 15.947Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M33.048 24.405c-2.842 3.528-10.456 2.14-16.941-3.042C9.62 16.18 6.649 8.95 9.68 5.503c2.842-3.528 10.457-2.14 16.942 3.043 6.485 5.181 9.458 12.413 6.425 15.859Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M33.048 24.404c-2.842 3.528-10.456 2.14-16.94-3.042C9.623 16.181 6.84 9.032 9.682 5.505c2.842-3.529 10.456-2.14 16.941 3.041 6.485 5.182 9.267 12.33 6.425 15.858Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M33.055 24.402c-2.843 3.53-10.458 2.141-16.945-3.042C9.624 16.176 6.841 9.025 9.59 5.693c2.842-3.53 10.457-2.14 16.944 3.043 6.486 5.183 9.27 12.334 6.521 15.666Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M32.86 24.314c-2.843 3.53-10.459 2.14-16.945-3.043C9.428 16.088 6.551 9.134 9.394 5.605c2.842-3.53 10.458-2.14 16.945 3.043 6.486 5.183 9.363 12.137 6.52 15.666Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M32.86 24.315c-2.842 3.529-10.457 2.14-16.752-2.96-6.295-5.1-9.362-12.134-6.52-15.663 2.842-3.529 10.457-2.14 16.752 2.96 6.295 5.1 9.362 12.134 6.52 15.663Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M32.854 24.321c-2.841 3.528-10.454 2.14-16.653-3.155C10 15.87 6.84 9.036 9.873 5.59c2.841-3.527 10.454-2.139 16.747 2.96 6.294 5.097 9.36 12.13 6.328 15.574l-.094.197Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M32.858 24.323c-2.842 3.53-10.171 2.026-16.657-3.157-6.486-5.182-9.172-12.052-6.33-15.58 2.842-3.53 10.172-2.026 16.658 3.156 6.485 5.182 9.172 12.052 6.33 15.581Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M32.663 24.235c-2.842 3.529-10.172 2.026-16.658-3.157-6.485-5.182-9.172-12.052-6.33-15.58 2.843-3.53 10.172-2.026 16.658 3.156 6.486 5.182 9.172 12.052 6.33 15.581Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M32.671 24.234c-2.842 3.53-10.173 2.026-16.468-3.075C9.907 16.06 7.03 9.105 9.777 5.773c2.842-3.53 10.173-2.026 16.468 3.075 6.296 5.1 9.173 12.054 6.425 15.386Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M32.672 24.236c-2.748 3.333-10.174 2.026-16.47-3.075C9.904 16.059 7.027 9.105 9.775 5.77c2.748-3.332 10.174-2.025 16.47 3.076 6.297 5.102 9.174 12.056 6.426 15.389Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M32.673 24.238c-2.748 3.332-10.173 2.026-16.469-3.075C9.908 16.062 7.031 9.108 9.97 5.858c2.748-3.332 10.173-2.026 16.469 3.075 6.296 5.101 9.173 12.055 6.234 15.305Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M32.673 24.237c-2.748 3.332-10.173 2.026-16.468-3.075-6.295-5.1-8.982-11.97-6.234-15.303 2.748-3.332 10.172-2.026 16.468 3.075 6.295 5.1 8.982 11.971 6.234 15.303Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M32.564 23.963c-2.748 3.33-10.171 2.025-16.275-2.992-6.104-5.017-9.075-11.771-6.233-15.3 2.747-3.331 10.17-2.025 16.275 2.992 6.104 5.017 9.075 11.771 6.233 15.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M32.564 23.963c-2.748 3.33-10.171 2.025-16.275-2.992-6.104-5.017-9.075-11.771-6.233-15.3 2.747-3.331 10.17-2.025 16.275 2.992 6.104 5.017 9.075 11.771 6.233 15.3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M32.571 23.961c-2.748 3.333-9.983 2.109-16.279-2.992-6.296-5.102-9.077-11.777-6.329-15.11 2.748-3.332 9.983-2.108 16.28 2.994 6.295 5.101 9.077 11.776 6.328 15.108Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M32.572 23.962c-2.748 3.332-9.981 2.108-16.277-2.992C10 15.87 7.41 9.279 10.157 5.947c2.748-3.332 9.982-2.108 16.277 2.992 6.296 5.1 8.886 11.691 6.138 15.023Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M32.377 23.875c-2.747 3.331-9.98 2.107-16.084-2.91C10.19 15.95 7.41 9.278 10.156 5.947c2.748-3.33 9.98-2.107 16.084 2.91 6.104 5.016 8.884 11.688 6.137 15.019Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M32.38 23.878c-2.748 3.332-9.888 1.911-16.088-2.91-6.2-4.822-8.886-11.693-6.138-15.025 2.748-3.332 9.887-1.911 16.087 2.91 6.2 4.822 8.886 11.693 6.139 15.025Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M32.38 23.878c-2.748 3.332-9.888 1.911-16.088-2.91-6.2-4.822-8.886-11.693-6.138-15.025 2.748-3.332 9.887-1.911 16.087 2.91 6.2 4.822 8.886 11.693 6.139 15.025Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M32.388 23.877C29.64 27.21 22.5 25.79 16.49 21.05S7.602 9.355 10.256 6.22c2.748-3.333 9.889-1.911 15.899 2.828 6.01 4.74 8.887 11.695 6.233 14.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M32.192 23.788c-2.748 3.333-9.889 1.912-15.898-2.828-6.01-4.739-8.696-11.61-6.233-14.828 2.748-3.333 9.888-1.912 15.898 2.828 6.009 4.739 8.696 11.61 6.233 14.828Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M32.194 23.79c-2.748 3.332-9.698 1.994-15.897-2.828-6.2-4.82-8.79-11.412-6.042-14.744 2.748-3.332 9.697-1.994 15.896 2.828 6.2 4.82 8.79 11.412 6.043 14.744Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M32.194 23.79c-2.748 3.332-9.698 1.994-15.897-2.828-6.2-4.82-8.79-11.412-6.042-14.744 2.748-3.332 9.697-1.994 15.896 2.828 6.2 4.82 8.79 11.412 6.043 14.744Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M32.193 23.79c-2.747 3.332-9.697 1.993-15.896-2.828-6.01-4.738-8.79-11.412-6.042-14.744 2.748-3.332 9.697-1.993 15.896 2.828 6.01 4.738 8.79 11.412 6.042 14.744Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M32.188 23.794c-2.748 3.331-9.696 1.993-15.8-3.025-6.01-4.738-8.79-11.41-6.042-14.742 2.748-3.332 9.696-1.993 15.8 3.024 6.009 4.738 8.79 11.411 6.042 14.743Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M32.188 23.794c-2.748 3.331-9.696 1.993-15.8-3.025-6.01-4.738-8.79-11.41-6.042-14.742 2.748-3.332 9.696-1.993 15.8 3.024 6.009 4.738 8.79 11.411 6.042 14.743Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M32.189 23.795c-2.747 3.33-9.695 1.992-15.608-2.942-6.007-4.737-8.787-11.408-6.04-14.739 2.747-3.33 9.694-1.992 15.607 2.942 6.008 4.737 8.788 11.408 6.04 14.739Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M32.189 23.795c-2.747 3.33-9.695 1.992-15.608-2.942-6.007-4.737-8.787-11.408-6.04-14.739 2.747-3.33 9.694-1.992 15.607 2.942 6.008 4.737 8.788 11.408 6.04 14.739Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M32.189 23.795c-2.747 3.33-9.695 1.992-15.608-2.942-6.007-4.737-8.787-11.408-6.04-14.739 2.747-3.33 9.694-1.992 15.607 2.942 6.008 4.737 8.788 11.408 6.04 14.739Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M32.189 23.795c-2.747 3.33-9.695 1.992-15.608-2.942-6.007-4.737-8.787-11.408-6.04-14.739 2.747-3.33 9.694-1.992 15.607 2.942 6.008 4.737 8.788 11.408 6.04 14.739Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M32.189 23.795c-2.747 3.33-9.695 1.992-15.608-2.942-6.007-4.737-8.787-11.408-6.04-14.739 2.747-3.33 9.694-1.992 15.607 2.942 6.008 4.737 8.788 11.408 6.04 14.739Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M32.19 23.796c-2.653 3.134-9.695 1.992-15.609-2.942-6.008-4.738-8.789-11.41-6.041-14.742 2.653-3.134 9.695-1.993 15.61 2.942 6.007 4.738 8.788 11.41 6.04 14.742Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M31.994 23.706c-2.653 3.135-9.695 1.993-15.608-2.941-6.008-4.737-8.598-11.327-6.041-14.74 2.653-3.134 9.695-1.993 15.608 2.941 6.008 4.738 8.598 11.327 6.041 14.74Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M32.001 23.705c-2.653 3.135-9.697 1.993-15.612-2.943-6.01-4.74-8.6-11.331-6.137-14.549 2.653-3.135 9.697-1.994 15.612 2.943 6.01 4.739 8.6 11.331 6.137 14.549Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M32.001 23.705c-2.653 3.135-9.697 1.993-15.612-2.943-6.01-4.74-8.6-11.331-6.137-14.549 2.653-3.135 9.697-1.994 15.612 2.943 6.01 4.739 8.6 11.331 6.137 14.549Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M32.001 23.705c-2.653 3.135-9.697 1.993-15.612-2.943-6.01-4.74-8.6-11.331-6.137-14.549 2.653-3.135 9.697-1.994 15.612 2.943 6.01 4.739 8.6 11.331 6.137 14.549Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M32.003 23.707c-2.654 3.135-9.697 1.993-15.611-2.943-6.01-4.738-8.6-11.33-5.946-14.464 2.653-3.135 9.697-1.994 15.611 2.942 6.009 4.738 8.6 11.33 5.946 14.465Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M32.004 23.708c-2.653 3.134-9.695 1.993-15.418-2.86-6.008-4.737-8.598-11.327-5.945-14.46 2.653-3.135 9.695-1.994 15.418 2.858 6.008 4.738 8.598 11.328 5.945 14.462Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M32.004 23.708c-2.653 3.134-9.695 1.993-15.418-2.86-6.008-4.737-8.598-11.327-5.945-14.46 2.653-3.135 9.695-1.994 15.418 2.858 6.008 4.738 8.598 11.328 5.945 14.462Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M32.004 23.708c-2.653 3.134-9.695 1.993-15.418-2.86-6.008-4.737-8.598-11.327-5.945-14.46 2.653-3.135 9.695-1.994 15.418 2.858 6.008 4.738 8.598 11.328 5.945 14.462Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M32.004 23.708c-2.653 3.134-9.695 1.993-15.418-2.86-6.008-4.737-8.598-11.327-5.945-14.46 2.653-3.135 9.695-1.994 15.418 2.858 6.008 4.738 8.598 11.328 5.945 14.462Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M32.09 23.521c-2.653 3.134-9.696 1.993-15.419-2.86-6.008-4.737-8.598-11.326-5.945-14.46 2.653-3.135 9.696-1.993 15.419 2.859 6.008 4.737 8.598 11.327 5.945 14.461Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M32.091 23.525c-2.653 3.136-9.603 1.797-15.422-2.86-6.009-4.74-8.6-11.331-5.946-14.467 2.654-3.135 9.603-1.796 15.422 2.86 6.01 4.74 8.6 11.332 5.946 14.467Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M32.091 23.525c-2.653 3.136-9.412 1.88-15.422-2.86-6.009-4.74-8.6-11.331-5.946-14.467 2.654-3.135 9.413-1.879 15.422 2.86 6.01 4.74 8.6 11.332 5.946 14.467Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M31.896 23.437c-2.654 3.135-9.413 1.879-15.422-2.86-6.01-4.74-8.6-11.332-5.947-14.467 2.654-3.136 9.413-1.88 15.422 2.86 6.01 4.74 8.6 11.331 5.947 14.467Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M31.895 23.436c-2.653 3.135-9.412 1.879-15.42-2.86-6.01-4.739-8.41-11.248-5.947-14.465 2.654-3.135 9.412-1.879 15.421 2.86 6.01 4.739 8.41 11.248 5.946 14.465Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M31.896 23.436c-2.654 3.135-9.412 1.879-15.421-2.86-5.819-4.657-8.41-11.248-5.946-14.465 2.653-3.135 9.412-1.879 15.42 2.86 5.82 4.656 8.504 11.05 5.947 14.465Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M31.896 23.436c-2.654 3.135-9.412 1.879-15.421-2.86-5.819-4.657-8.504-11.05-5.946-14.465 2.653-3.135 9.412-1.879 15.42 2.86 5.82 4.656 8.504 11.05 5.947 14.465Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M31.896 23.436c-2.654 3.135-9.412 1.879-15.421-2.86-5.819-4.657-8.504-11.05-5.946-14.465 2.653-3.135 9.412-1.879 15.42 2.86 5.82 4.656 8.504 11.05 5.947 14.465Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M31.896 23.436c-2.654 3.135-9.412 1.879-15.421-2.86-5.819-4.657-8.504-11.05-5.946-14.465 2.653-3.135 9.412-1.879 15.42 2.86 5.82 4.656 8.504 11.05 5.947 14.465Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M31.905 23.435c-2.654 3.136-9.414 1.88-15.424-2.86-5.82-4.659-8.505-11.055-5.851-14.19 2.654-3.137 9.414-1.88 15.424 2.86 5.82 4.658 8.505 11.054 5.85 14.19Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M31.905 23.436c-2.653 3.135-9.412 1.879-15.23-2.778-5.819-4.656-8.504-11.05-5.85-14.186 2.653-3.135 9.412-1.879 15.23 2.778 5.82 4.656 8.504 11.05 5.85 14.186Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M31.71 23.348c-2.653 3.135-9.412 1.878-15.23-2.778-5.82-4.657-8.504-11.051-5.85-14.187 2.653-3.135 9.412-1.878 15.23 2.778 5.819 4.657 8.504 11.051 5.85 14.187Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M31.71 23.348c-2.653 3.135-9.412 1.878-15.23-2.778-5.82-4.657-8.504-11.051-5.85-14.187 2.653-3.135 9.412-1.878 15.23 2.778 5.819 4.657 8.504 11.051 5.85 14.187Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M31.71 23.347c-2.654 3.135-9.412 1.879-15.23-2.777-5.819-4.657-8.313-10.968-5.85-14.186 2.653-3.134 9.411-1.878 15.23 2.778 5.818 4.656 8.312 10.968 5.85 14.185Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M31.71 23.347c-2.654 3.135-9.412 1.879-15.23-2.777-5.819-4.657-8.313-10.968-5.85-14.186 2.653-3.134 9.411-1.878 15.23 2.778 5.818 4.656 8.312 10.968 5.85 14.185Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M31.71 23.347c-2.654 3.135-9.412 1.879-15.23-2.777-5.819-4.657-8.313-10.968-5.85-14.186 2.653-3.134 9.411-1.878 15.23 2.778 5.818 4.656 8.312 10.968 5.85 14.185Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M31.71 23.348c-2.653 3.134-9.41 1.878-15.037-2.695-5.817-4.655-8.31-10.965-5.848-14.181 2.652-3.135 9.41-1.878 15.037 2.694 5.817 4.655 8.31 10.965 5.848 14.182Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M31.71 23.348c-2.653 3.134-9.41 1.878-15.037-2.695-5.817-4.655-8.31-10.965-5.848-14.181 2.652-3.135 9.41-1.878 15.037 2.694 5.817 4.655 8.31 10.965 5.848 14.182Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M31.71 23.348c-2.653 3.134-9.41 1.878-15.037-2.695-5.817-4.655-8.31-10.965-5.848-14.181 2.652-3.135 9.41-1.878 15.037 2.694 5.817 4.655 8.31 10.965 5.848 14.182Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M31.712 23.35c-2.653 3.134-9.41 1.878-15.036-2.694C10.86 16 8.366 9.692 11.018 6.558c2.653-3.134 9.41-1.878 15.036 2.694 5.817 4.655 8.31 10.964 5.658 14.098Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M31.712 23.35c-2.653 3.134-9.219 1.96-15.036-2.694C10.86 16 8.366 9.692 11.018 6.558c2.653-3.134 9.22-1.96 15.036 2.694 5.817 4.655 8.31 10.964 5.658 14.098Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M31.719 23.348c-2.654 3.135-9.222 1.961-15.04-2.695-5.819-4.656-8.313-10.968-5.754-13.906 2.653-3.136 9.221-1.961 15.04 2.695 5.818 4.656 8.313 10.968 5.754 13.906Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M31.719 23.348c-2.654 3.135-9.222 1.961-15.04-2.695-5.819-4.656-8.313-10.968-5.754-13.906 2.653-3.136 9.221-1.961 15.04 2.695 5.818 4.656 8.313 10.968 5.754 13.906Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M31.523 23.26c-2.653 3.135-9.221 1.96-15.04-2.695C10.857 15.99 8.172 9.596 10.73 6.658c2.653-3.135 9.221-1.96 15.04 2.696 5.628 4.574 8.312 10.968 5.753 13.906Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M31.522 23.259c-2.653 3.135-9.22 1.96-15.038-2.695C10.856 15.99 8.267 9.876 10.73 6.659c2.653-3.135 9.22-1.96 15.039 2.695 5.628 4.574 8.216 10.688 5.753 13.905Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M31.524 23.26c-2.653 3.134-9.22 1.96-14.846-2.612-5.627-4.572-8.215-10.685-5.753-13.901 2.653-3.134 9.22-1.96 14.846 2.612 5.627 4.572 8.215 10.685 5.753 13.901Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M31.527 23.263c-2.653 3.136-9.127 1.764-14.85-2.613C11.05 16.076 8.46 9.96 10.923 6.742c2.559-2.938 9.127-1.764 14.85 2.613 5.629 4.575 8.218 10.69 5.755 13.908Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M31.522 23.27c-2.559 2.937-9.127 1.763-14.755-2.81-5.628-4.575-8.217-10.69-5.754-13.908 2.559-2.938 9.127-1.764 14.755 2.81s8.217 10.69 5.754 13.907Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M31.524 23.27c-2.56 2.939-9.127 1.765-14.754-2.809-5.628-4.573-8.217-10.688-5.563-13.823 2.558-2.938 9.126-1.764 14.754 2.81 5.627 4.574 8.216 10.688 5.563 13.823Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M31.53 23.27c-2.56 2.938-9.129 1.764-14.758-2.812-5.63-4.575-8.219-10.692-5.66-13.631 2.56-2.94 9.13-1.765 14.76 2.81 5.628 4.576 8.218 10.693 5.564 13.83l.094-.198Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M31.335 23.18c-2.56 2.94-9.13 1.765-14.759-2.81-5.629-4.576-8.218-10.693-5.659-13.632 2.56-2.939 9.13-1.765 14.759 2.811s8.218 10.693 5.659 13.632Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M31.335 23.182c-2.559 2.938-9.127 1.764-14.565-2.728-5.628-4.575-8.217-10.69-5.658-13.628 2.559-2.939 9.127-1.765 14.565 2.728 5.629 4.574 8.218 10.69 5.659 13.628Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M31.336 23.181c-2.56 2.938-8.937 1.846-14.565-2.728S8.745 9.847 11.113 6.826c2.56-2.938 8.937-1.846 14.565 2.728s8.026 10.607 5.658 13.627Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M31.336 23.181c-2.369 3.02-8.937 1.846-14.565-2.728S8.745 9.847 11.113 6.826c2.369-3.02 8.937-1.846 14.565 2.728s8.026 10.607 5.658 13.627Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M31.421 22.994c-2.368 3.02-8.936 1.847-14.564-2.727S8.83 9.66 11.199 6.64c2.368-3.02 8.937-1.847 14.564 2.727 5.628 4.574 8.027 10.607 5.658 13.627Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M31.42 22.994c-2.368 3.02-8.936 1.847-14.563-2.727C11.419 15.775 8.83 9.66 11.199 6.64c2.368-3.02 8.936-1.846 14.564 2.728 5.438 4.491 8.026 10.606 5.658 13.626Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M31.423 22.996c-2.368 3.02-8.936 1.846-14.563-2.727-5.437-4.491-8.025-10.605-5.467-13.543 2.368-3.02 8.936-1.846 14.563 2.727 5.437 4.491 8.026 10.605 5.467 13.543Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M31.228 22.909c-2.368 3.019-8.934 1.845-14.37-2.644-5.436-4.49-8.024-10.603-5.466-13.54 2.368-3.019 8.934-1.845 14.37 2.645s8.024 10.602 5.466 13.539Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M31.235 22.907c-2.368 3.02-8.936 1.847-14.374-2.645-5.438-4.492-8.12-10.41-5.562-13.348 2.369-3.021 8.937-1.847 14.374 2.645 5.438 4.492 8.121 10.41 5.562 13.348Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M31.234 22.906c-2.368 3.02-8.936 1.847-14.373-2.645-5.437-4.491-7.93-10.326-5.562-13.347 2.369-3.02 8.936-1.846 14.374 2.645 5.437 4.492 7.93 10.327 5.561 13.347Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M31.234 22.906c-2.368 3.02-8.936 1.847-14.373-2.645-5.437-4.491-7.93-10.326-5.562-13.347 2.369-3.02 8.936-1.846 14.374 2.645 5.437 4.492 7.93 10.327 5.561 13.347Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M31.234 22.906c-2.368 3.02-8.936 1.847-14.373-2.645-5.437-4.491-7.93-10.326-5.562-13.347 2.369-3.02 8.936-1.846 14.374 2.645 5.437 4.492 7.93 10.327 5.561 13.347Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M31.234 22.906c-2.368 3.02-8.936 1.847-14.373-2.645-5.437-4.491-7.93-10.326-5.562-13.347 2.369-3.02 8.936-1.846 14.374 2.645 5.437 4.492 7.93 10.327 5.561 13.347Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M31.238 22.91c-2.369 3.02-8.843 1.65-14.184-2.563-5.438-4.492-7.93-10.328-5.562-13.349 2.368-3.02 8.842-1.649 14.184 2.564 5.437 4.492 7.93 10.327 5.562 13.348Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M31.044 22.824c-2.368 3.02-8.651 1.731-14.183-2.563-5.437-4.491-7.93-10.326-5.37-13.264 2.367-3.02 8.65-1.732 14.182 2.562 5.437 4.492 7.93 10.327 5.371 13.265Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M31.044 22.824c-2.368 3.02-8.651 1.731-14.183-2.563-5.437-4.491-7.93-10.326-5.37-13.264 2.367-3.02 8.65-1.732 14.182 2.562 5.437 4.492 7.93 10.327 5.371 13.265Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD73F",
    d: "M31.043 22.823c-2.368 3.02-8.65 1.731-14.182-2.563-5.437-4.49-7.739-10.243-5.37-13.262 2.368-3.02 8.65-1.732 14.181 2.562 5.437 4.49 7.739 10.243 5.37 13.263Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A25A00",
    style: {
      mixBlendMode: "screen"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m25.898 8.424-8.712 13.453.536.236 8.624-13.265-.536-.236.088-.188ZM23.664 6.69c-2.786-1.667-5.571-2.87-8.168-3.064l-6.372 9.535c1.12 2.337 2.981 4.996 5.491 7.238l8.957-13.518.092-.192ZM30.133 12.272c-.73-.776-1.552-1.822-2.556-2.487l-8.792 13.37c1.093.476 2.097 1.142 3.1 1.808l8.158-12.501.09-.19ZM32.805 16.228s-1.098-1.854-1.921-2.9L22.99 25.265c1.095.476 2.007.873 3.1.89l6.532-10.005.182.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M24.494 27.053c-1.486 1.679-3.65 1.9-5.36.691-1.62-1.401-1.741-3.546-.444-5.306 1.486-1.679 3.65-1.9 5.36-.691 1.62 1.401 1.74 3.546.444 5.306Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13.672,
    x2: 37.261,
    y1: 3.401,
    y2: 22.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EFBE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDB938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DE972C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D68225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D37B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DA8F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBC017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F6DE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 14.663,
    x2: 38.336,
    y1: 2.132,
    y2: 21.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#DA901C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B8720F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A35F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9C5905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A46714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CBA657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E7D489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F8F1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69F49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 21.69,
    x2: 43.451,
    y1: 13.134,
    y2: 0.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.696,
    x2: 43.462,
    y1: 13.127,
    y2: 0.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 21.691,
    x2: 43.458,
    y1: 13.121,
    y2: 0.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 21.691,
    x2: 43.458,
    y1: 13.121,
    y2: 0.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 21.695,
    x2: 43.456,
    y1: 13.128,
    y2: 0.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 21.696,
    x2: 43.455,
    y1: 13.128,
    y2: 0.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 21.7,
    x2: 43.466,
    y1: 13.122,
    y2: 0.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 21.695,
    x2: 43.461,
    y1: 13.116,
    y2: 0.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 21.697,
    x2: 43.459,
    y1: 13.119,
    y2: 0.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 21.694,
    x2: 43.449,
    y1: 13.13,
    y2: 0.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 21.696,
    x2: 43.458,
    y1: 13.128,
    y2: 0.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 21.69,
    x2: 43.453,
    y1: 13.122,
    y2: 0.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 21.698,
    x2: 43.463,
    y1: 13.119,
    y2: 0.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 21.697,
    x2: 43.465,
    y1: 13.119,
    y2: 0.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 21.7,
    x2: 43.465,
    y1: 13.123,
    y2: 0.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 21.7,
    x2: 43.464,
    y1: 13.123,
    y2: 0.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 21.688,
    x2: 43.448,
    y1: 13.13,
    y2: 0.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 21.688,
    x2: 43.448,
    y1: 13.13,
    y2: 0.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 21.693,
    x2: 43.46,
    y1: 13.125,
    y2: 0.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 21.696,
    x2: 43.459,
    y1: 13.128,
    y2: 0.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 21.693,
    x2: 43.451,
    y1: 13.125,
    y2: 0.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 21.693,
    x2: 43.458,
    y1: 13.124,
    y2: 0.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 21.693,
    x2: 43.458,
    y1: 13.124,
    y2: 0.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 21.7,
    x2: 43.468,
    y1: 13.122,
    y2: 0.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 21.695,
    x2: 43.461,
    y1: 13.117,
    y2: 0.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 21.698,
    x2: 43.462,
    y1: 13.12,
    y2: 0.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 21.698,
    x2: 43.462,
    y1: 13.12,
    y2: 0.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 21.697,
    x2: 42.977,
    y1: 13.12,
    y2: 1.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED75D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 21.866,
    x2: 42.45,
    y1: 13.264,
    y2: 0.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 22.19,
    x2: 41.956,
    y1: 13.221,
    y2: 1.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDE96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCD95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 22.193,
    x2: 41.439,
    y1: 13.224,
    y2: 0.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FDE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBD85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCF55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 22.366,
    x2: 40.943,
    y1: 13.364,
    y2: 1.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACD53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 22.366,
    x2: 40.609,
    y1: 13.364,
    y2: 1.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9CA50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 22.69,
    x2: 40.262,
    y1: 13.32,
    y2: 1.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C84E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 22.863,
    x2: 39.577,
    y1: 13.46,
    y2: 1.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FAD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C54C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 22.864,
    x2: 39.243,
    y1: 13.459,
    y2: 1.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9D355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 23.032,
    x2: 38.885,
    y1: 13.593,
    y2: 1.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9D254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 23.187,
    x2: 38.407,
    y1: 13.404,
    y2: 1.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE15D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F8D152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 23.361,
    x2: 38.053,
    y1: 13.544,
    y2: 1.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F8D050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BB42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 23.361,
    x2: 37.903,
    y1: 13.544,
    y2: 1.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 23.536,
    x2: 37.397,
    y1: 13.687,
    y2: 1.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CD4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B73D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 23.536,
    x2: 37.056,
    y1: 13.687,
    y2: 1.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8CC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B43B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 23.86,
    x2: 36.697,
    y1: 13.643,
    y2: 1.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7CB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 23.86,
    x2: 36.355,
    y1: 13.643,
    y2: 1.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDDA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7CA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EEB137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAF36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 24.034,
    x2: 36.186,
    y1: 13.783,
    y2: 1.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7C944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EEB034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 24.034,
    x2: 35.843,
    y1: 13.783,
    y2: 1.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDAF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 24.207,
    x2: 35.328,
    y1: 13.923,
    y2: 2.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EDAE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 24.209,
    x2: 35.178,
    y1: 13.927,
    y2: 2.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDAD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA52C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 24.533,
    x2: 34.812,
    y1: 13.883,
    y2: 2.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ECAC2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A32A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 24.533,
    x2: 34.663,
    y1: 13.883,
    y2: 2.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C43A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ECAB2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 24.533,
    x2: 34.317,
    y1: 13.883,
    y2: 2.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBAA2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 24.698,
    x2: 34.135,
    y1: 14.033,
    y2: 2.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 24.698,
    x2: 33.791,
    y1: 14.034,
    y2: 2.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 24.698,
    x2: 33.791,
    y1: 14.034,
    y2: 2.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 24.693,
    x2: 33.786,
    y1: 14.027,
    y2: 2.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 24.693,
    x2: 33.785,
    y1: 14.028,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 24.693,
    x2: 33.786,
    y1: 14.028,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 24.693,
    x2: 33.786,
    y1: 14.028,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 24.693,
    x2: 33.786,
    y1: 14.028,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 24.693,
    x2: 33.786,
    y1: 14.028,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 24.701,
    x2: 33.796,
    y1: 14.024,
    y2: 2.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 24.703,
    x2: 33.796,
    y1: 14.027,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 24.703,
    x2: 33.796,
    y1: 14.027,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 24.703,
    x2: 33.796,
    y1: 14.027,
    y2: 2.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 24.703,
    x2: 33.647,
    y1: 14.027,
    y2: 2.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 24.703,
    x2: 33.647,
    y1: 14.027,
    y2: 2.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 24.703,
    x2: 33.647,
    y1: 14.027,
    y2: 2.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 24.703,
    x2: 33.647,
    y1: 14.027,
    y2: 2.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 24.703,
    x2: 33.647,
    y1: 14.027,
    y2: 2.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 24.849,
    x2: 33.644,
    y1: 13.838,
    y2: 2.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 24.849,
    x2: 33.644,
    y1: 13.838,
    y2: 2.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 24.848,
    x2: 33.642,
    y1: 13.838,
    y2: 2.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 24.848,
    x2: 33.642,
    y1: 13.838,
    y2: 2.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 24.848,
    x2: 33.642,
    y1: 13.838,
    y2: 2.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 24.85,
    x2: 33.642,
    y1: 13.841,
    y2: 2.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 24.85,
    x2: 33.642,
    y1: 13.841,
    y2: 2.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 24.85,
    x2: 33.642,
    y1: 13.841,
    y2: 2.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 24.852,
    x2: 33.643,
    y1: 13.845,
    y2: 2.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 24.852,
    x2: 33.643,
    y1: 13.845,
    y2: 2.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 9.611,
    x2: 18.299,
    y1: 26.048,
    y2: 15.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 29.003,
    x2: 37.504,
    y1: 11.079,
    y2: 0.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 15.03,
    x2: 23.565,
    y1: 21.784,
    y2: 10.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 2.351,
    x2: 10.774,
    y1: 31.755,
    y2: 20.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 21.269,
    x2: 29.496,
    y1: 17.542,
    y2: 6.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 9.539,
    x2: 17.658,
    y1: 26.388,
    y2: 15.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 26.892,
    x2: 34.819,
    y1: 12.501,
    y2: 1.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 16.949,
    x2: 24.888,
    y1: 21.066,
    y2: 9.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 7.881,
    x2: 15.703,
    y1: 28.543,
    y2: 16.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAE2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 23.674,
    x2: 31.301,
    y1: 15.673,
    y2: 4.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 15.8,
    x2: 23.304,
    y1: 21.936,
    y2: 10.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B32D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 8.727,
    x2: 16.107,
    y1: 27.885,
    y2: 16.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B62E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 22.668,
    x2: 29.851,
    y1: 16.43,
    y2: 4.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 16.729,
    x2: 23.903,
    y1: 21.527,
    y2: 9.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 11.739,
    x2: 18.784,
    y1: 26.176,
    y2: 14.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BD32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 23.222,
    x2: 30.067,
    y1: 16.053,
    y2: 4.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 18.828,
    x2: 25.541,
    y1: 19.908,
    y2: 7.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 15.305,
    x2: 21.89,
    y1: 23.539,
    y2: 11.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 12.629,
    x2: 19.183,
    y1: 26.221,
    y2: 13.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 20.517,
    x2: 26.87,
    y1: 17.979,
    y2: 5.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 18.406,
    x2: 24.721,
    y1: 20.892,
    y2: 8.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACB39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 23.569,
    x2: 29.682,
    y1: 14.034,
    y2: 1.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 21.316,
    x2: 27.291,
    y1: 16.517,
    y2: 3.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FCD13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 19.417,
    x2: 25.339,
    y1: 18.704,
    y2: 5.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 18.811,
    x2: 24.588,
    y1: 20.199,
    y2: 7.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED53E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(38.713 -11.512 51.402) scale(3.76728 3.93984)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinSmall);
export default __webpack_public_path__ + "static/media/coin-small.9f0cf48bedcb797c93d1866d62bc5b9d.svg";
export { ForwardRef as ReactComponent };